<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Global Styles - Apple Inspired */
:root {
  --apple-font: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --bg-color: #ffffff;
  --bg-secondary: #f5f5f7;
  --bg-dark: #000000;
  --bg-dark-secondary: #121215;
  --text-color: #1d1d1f;
  --text-secondary: #86868b;
  --text-light: #f5f5f7;
  --accent-color: #0071e3;
  --accent-hover: #0077ed;
  --glass-bg: rgba(255, 255, 255, 0.82);
  --glass-dark: rgba(22, 22, 24, 0.85);
  --border-subtle: rgba(0, 0, 0, 0.08);
  --border-dark: rgba(255, 255, 255, 0.12);
  --apple-glow: linear-gradient(135deg, #ff3b30, #ff9500, #ffcc00, #34c759, #007aff, #5856d6, #af52de);
}

html {
  scroll-behavior: smooth;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  background-color: var(--bg-color);
  color: var(--text-color);
  font-family: var(--apple-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.47059;
  font-weight: 400;
  letter-spacing: -0.022em;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* Completely remove scrollbars for Chrome, Safari, Edge, Firefox, and Opera */
html,
body,
#app,
* {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

*::-webkit-scrollbar,
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

* {
  box-sizing: border-box;
}

#app {
  width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-weight: 600;
  letter-spacing: -0.015em;
}

a {
  text-decoration: none;
  color: var(--accent-color);
  transition: opacity 0.2s ease, color 0.2s ease;
}

a:hover {
  opacity: 0.85;
}
</style>
